import type { SVGProps } from 'react';

type Props = { width?: number; height?: number; color?: string } & SVGProps<SVGSVGElement>;

export const SVG = (props: Props) => (
  <svg width={props.width} height={props.height} viewBox='0 0 27 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.78571 9.6875V9.20312C5.78571 5.72773 8.5942 2.90625 12.0536 2.90625H14.9464C18.4058 2.90625 21.2143 5.72773 21.2143 9.20312V9.6875H24.1071V9.20312C24.1071 4.12324 20.0029 0 14.9464 0H12.0536C6.9971 0 2.89286 4.12324 2.89286 9.20312V9.6875H5.78571Z'
      fill={props?.color || 'currentColor'}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.92857 11.625C0.861832 11.625 0 12.4908 0 13.5625C0 14.6342 0.861832 15.5 1.92857 15.5H2.23594L3.58594 28.3965C3.73661 29.8799 4.97813 31 6.46072 31H20.5393C22.0158 31 23.2574 29.8738 23.4141 28.3965L24.7641 15.5H25.0714C26.1382 15.5 27 14.6342 27 13.5625C27 12.4908 26.1382 11.625 25.0714 11.625H1.92857ZM21 15.5H6L7 28H20L21 15.5Z'
      fill={props?.color || 'currentColor'}
    />
  </svg>
);

export default SVG;

// import type { SVGProps } from 'react';

// type Props = { width?: number; height?: number; color?: string } & SVGProps<SVGSVGElement>;

// export const SVG = (props: Props) => (
//   <svg width={props.width} height={props.height} viewBox='0 0 27 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
//     <path
//       d='M5.78571 9.6875V9.20312C5.78571 5.72773 8.5942 2.90625 12.0536 2.90625H14.9464C18.4058 2.90625 21.2143 5.72773 21.2143 9.20312V9.6875H24.1071V9.20312C24.1071 4.12324 20.0029 0 14.9464 0H12.0536C6.9971 0 2.89286 4.12324 2.89286 9.20312V9.6875H5.78571Z'
//       fill={props?.color || 'currentColor'}
//     />
//     <path
//       fillRule='evenodd'
//       clipRule='evenodd'
//       d='M1.92857 11.625C0.861832 11.625 0 12.4908 0 13.5625C0 14.6342 0.861832 15.5 1.92857 15.5H2.23594L3.58594 28.3965C3.73661 29.8799 4.97813 31 6.46072 31H20.5393C22.0158 31 23.2574 29.8738 23.4141 28.3965L24.7641 15.5H25.0714C26.1382 15.5 27 14.6342 27 13.5625C27 12.4908 26.1382 11.625 25.0714 11.625H1.92857ZM21 15.5H6L7 28H20L21 15.5Z'
//       fill={props?.color || 'currentColor'}
//     />
//   </svg>
// );

// export default SVG;
